import { ref, type Ref } from 'vue';

import { createSingleton } from '@deepidoo/deesplay-shared/utils';

export type Languages = 'de-DE' | 'fr-FR' | 'en-US';
type Keys = 'agent-chat.title' | 'agent-chat.reconnecting' | 'agent-chat.welcome';

const translations: Record<Languages, Record<Keys, string>> = {
    'en-US': {
        'agent-chat.title': 'Chatbot',
        'agent-chat.reconnecting': 'Connection to chatbot lost. Retrying...',
        'agent-chat.welcome': `Hello, how can I help you today?
For now, I can:
- search organizations
- search tags
- search artists
- search, create, edit, delete, duplicate and add tracks to playlists
- search, create, edit, delete and add slots to plannings

Try me! You can speak in any language you want, I will answer you in the same language.`
    },
    'fr-FR': {
        'agent-chat.title': 'Chatbot',
        'agent-chat.reconnecting': 'Connection au chatbot perdue. Reconnexion...',
        'agent-chat.welcome': `Bonjour, comment puis-je vous aider aujourd'hui ?
Pour l'instant, je peux :
- rechercher des organisations
- rechercher des tags
- rechercher des artistes
- rechercher, créer, modifier, supprimer, dupliquer et ajouter des pistes à des playlists
- rechercher, créer, modifier, supprimer et ajouter des slots à des plannings

Essayez-moi ! Vous pouvez parler dans n'importe quelle langue, je vous répondrai dans la même langue.`
    },
    'de-DE': {
        'agent-chat.title': 'Chatbot',
        'agent-chat.reconnecting': 'Verbindung zum Chatbot verloren. Wiederholen...',
        'agent-chat.welcome': `Hallo, wie kann ich Ihnen heute helfen?
Derzeit kann ich:
- nach Organisationen suchen
- nach Tags suchen
- nach Künstlern suchen
- nach Tracks suchen, erstellen, bearbeiten, löschen, duplizieren und zu Playlists hinzufügen
- nach Slots suchen, erstellen, bearbeiten, löschen und zu Plannings hinzufügen.

Versuche mich! Sie können in jeder Sprache sprechen, ich werde Ihnen in der gleichen Sprache antworten.`
    }
};

export const useTranslations = createSingleton((): {
    languageCode: Ref<Languages>;
    tr: (key: Keys) => string;
} => {
    const languageCode = ref<Languages>('en-US');

    const tr = (key: Keys): string => {
        return translations[languageCode.value][key] || key;
    };

    return {
        languageCode,
        tr
    };
});